export default class Unita{
    CodiceUnita;
    Descrizione;
    Magazzini;
    SysChiaveglobale;

    constructor(){}
}